import { ArrowUpRight } from "lucide-react";
import { BRAND, PRODUCTS } from "@/content";

export default function Shop() {
  return (
    <div data-testid="page-shop" className="bg-white">
      <section className="pt-[120px] pb-16">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-12 gap-10 items-end">
          <div className="col-span-12 lg:col-span-8">
            <p className="overline">Shop</p>
            <h1 className="display mt-6 text-[44px] md:text-[120px]">
              Tools for<br/>choosing <em className="font-serif text-[var(--ic-accent)]">you</em>.
            </h1>
          </div>
          <div className="col-span-12 lg:col-span-4">
            <p className="font-sans text-[17px] leading-[1.75] text-black/75">
              Affirmation decks, planners, and editions for couples, students, and teams.
              Each one designed around a single belief: one choice can change your life.
            </p>
            <a href={BRAND.shop} target="_blank" rel="noreferrer" data-testid="shop-visit-square"
               className="btn-ghost mt-6 inline-flex">
              Visit the Square Shop <ArrowUpRight size={16}/>
            </a>
          </div>
        </div>
      </section>

      <section className="hairline-b">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-10">
          <div className="zoom-img-wrap relative overflow-hidden border border-[var(--ic-line)] aspect-[16/9] bg-[var(--ic-warm)]">
            <img src={BRAND.images.products} alt="An I Choose Movement affirmation card" className="zoom-img absolute inset-0 w-full h-full object-cover object-[center_40%]" />
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
            <div>
              <p className="overline">The collection</p>
              <h2 className="section-display mt-4">All products.</h2>
            </div>
            <span className="text-[13px] text-black/55">Checkout opens on Square.</span>
          </div>

          <div className="grid grid-cols-12 gap-6 lg:gap-8">
            {PRODUCTS.map((p, i) => (
              <a key={i} href={p.href} target="_blank" rel="noreferrer" data-testid={`product-${i}`}
                 className="col-span-12 sm:col-span-6 lg:col-span-4 border border-[var(--ic-line)] bg-white hover:bg-[var(--ic-warm)] transition-colors p-8 flex flex-col">
                <p className="overline">0{i+1}</p>
                <h3 className="font-serif text-[28px] mt-6 leading-tight">{p.title}</h3>
                <p className="text-[14.5px] text-black/70 mt-3 leading-relaxed">{p.desc}</p>
                <span className="ed-link mt-8 self-start text-[11px]">
                  Shop on Square <ArrowUpRight size={14} className="inline -mt-0.5"/>
                </span>
              </a>
            ))}

            <div className="col-span-12 sm:col-span-6 lg:col-span-4 border border-dashed border-[var(--ic-line)] p-8 flex flex-col justify-center bg-[var(--ic-warm)]" data-testid="future-products">
              <p className="overline">Coming soon</p>
              <h3 className="font-serif text-[26px] mt-6 leading-tight">More editions on the way.</h3>
              <p className="text-[14px] text-black/65 mt-3">Sign up on the contact page to be the first to know.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
